import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { Button, TextField } from '@bechtel/gds';

export const PlanningTargetCalcContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  height: 100vh;
  overflow: hidden;
`;

export const PlanningTargetCalcSubContainerStyled = styled(Box).attrs({
  mx: { sm: '500' },
  mt: { sm: '500' },
})`
  ${({ theme }) => css`
    height: 100vh;
    overflow: hidden;
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `}
`;

export const FooterButtonStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const PlanningTargetCalcFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding: ${theme.spacings[300]} ${theme.spacings[600]};
    white-space: nowrap;
  `}
`;

export const TextInputStyled = styled(TextField)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes[400]};
      font-family: ${theme.fontFamilies['graphik']};
      color: ${theme.colors.grey[1000]};
    `}
`;
export const Label = styled.label`
  display: flex;
  align-items: center;
`;

export const ProgressContainerStyled = styled(Box).attrs({
  pt: { sm: '200' },
  alignItems: { sm: 'center' },
  flexGrow: { sm: 0 },
})`
  overflow: hidden;
  height: 82px; /** TODO Remove child should determine its height */
  ${({ theme }) => css`
    background-image: linear-gradient(274deg, ${theme.colors.bechtel.blue[1000]}, ${theme.colors.bechtel.blue[800]});
    position: relative;
  `}
`;
